export default __webpack_public_path__ + "static/media/icon-wallet-browser.e3fdb2d7.svg";